<template>
  <div class="vz-news-switcher">
    <vz-button
      v-for="{ title, to } of pages"
      :to="to"
      outline
      large
      variant="primary"
    >{{ title }}</vz-button>
  </div>
</template>

<script setup lang="ts">
import VzButton from '~/components/ui-kit/vz-button.vue';

const pages = [
  {
    title: 'Новости',
    to: { name: 'news', params: { tag: 'news' } }
  },
  {
    title: 'Акции',
    to: { name: 'news', params: { tag: 'actions' } }
  }
]

</script>

<style scoped lang="scss">
.vz-news-switcher {
  display: flex;

  > a {
    width: 100%;
    display: flex;
    justify-content: center;

    &:first-child {
      margin-right: 10px;
    }
    &:last-child {
      margin-left: 10px;
    }
  }

  .router-link-exact-active {
    color: #fff;
    background-color: #EC1B22;
  }
}
</style>
